import { render } from "./CustomerChange.vue?vue&type=template&id=63b5c776"
import script from "./CustomerChange.vue?vue&type=script&lang=js"
export * from "./CustomerChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__